import { MosquitoNetSketch, WindowSketch, DoorSketch, ShutterSketch, type WindowSketchModel } from '@termovista/window-configurator'
import { isConfigurableDoorType } from '../../../shared/doors'
import type { ComponentProps } from 'react'
import type { ShutterConfiguration } from '../../../shared/shutters'
import type { MosquitoNetConfiguration } from '../../../shared/mosquitoNets'
export function ProductSketch(props: Omit<ComponentProps<typeof WindowSketch>, 'model'> & { model: WindowSketchModel & { elementType?: string | null; shutter?: ShutterConfiguration; mosquitoNet?: MosquitoNetConfiguration } }) {
  if (props.model.elementType === 'shutter') {
    if (!props.model.shutter?.controlSide) return <span>Shutter configuration needs review</span>
    return <ShutterSketch model={{ ...props.model.measurements, controlSide: props.model.shutter.controlSide }} showDimensions={props.showDimensions} className={props.className} />
  }
  if (props.model.elementType === 'mosquito_net') {
    if (!props.model.mosquitoNet) return <span>Mosquito-net configuration needs review</span>
    return <MosquitoNetSketch model={{ ...props.model.measurements, type: props.model.mosquitoNet.type, fixedSide: props.model.mosquitoNet.fixedSide }} showDimensions={props.showDimensions} className={props.className} />
  }
  return isConfigurableDoorType(props.model.elementType) ? <DoorSketch {...props} /> : <WindowSketch {...props} />
}
